import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/SiteLayout";

import Home from "@/pages/Home";
import PrivateCollection from "@/pages/PrivateCollection";
import SelectionStandard from "@/pages/SelectionStandard";
import Apply from "@/pages/Apply";
import Invitation from "@/pages/Invitation";
import Collection from "@/pages/Collection";
import PropertyDetail from "@/pages/PropertyDetail";
import FoundingMembersPage from "@/pages/FoundingMembers";
import About from "@/pages/About";
import ShareApply from "@/pages/ShareApply";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Applications from "@/pages/admin/Applications";
import ApplicationDetail from "@/pages/admin/ApplicationDetail";
import Invitations from "@/pages/admin/Invitations";
import ShareLinks from "@/pages/admin/ShareLinks";
import Properties from "@/pages/admin/Properties";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <AuthProvider>
      <Toaster
        position="top-center"
        toastOptions={{
          style: { background: "#102A46", color: "#F7F5EF", border: "1px solid rgba(198,161,91,0.3)", borderRadius: 0 },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/private-collection" element={<PrivateCollection />} />
            <Route path="/selection" element={<SelectionStandard />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/collection" element={<Collection />} />
            <Route path="/selected" element={<Collection />} />
            <Route path="/founding-members" element={<FoundingMembersPage />} />
            <Route path="/collection/:slug" element={<PropertyDetail />} />
            <Route path="/about" element={<About />} />
          </Route>

          {/* Standalone immersive pages (no chrome) */}
          <Route path="/invitation" element={<Invitation />} />
          <Route path="/candidatura/:code" element={<ShareApply />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="applications" element={<Applications />} />
            <Route path="applications/:id" element={<ApplicationDetail />} />
            <Route path="invitations" element={<Invitations />} />
            <Route path="share-links" element={<ShareLinks />} />
            <Route path="properties" element={<Properties />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
